<template>
<div>
  <Row>
    <!-- 适配手机版 -->
    <Col :xs="{ span: 24 }" :lg="{ span: 0 }">
        <div style="padding:17px 0 15px 0;display:flex;justify-content:space-between;">
          <Icon @click="chouti=true" type="md-menu" size='25' style="color:#fff;margin-top:15px;"/>
          <img src="../assets/image/logo.png" style="width:220px;height:auto">
          <div></div>
        </div>
        <Drawer title="" :closable="false" v-model="chouti">
            <div v-for="(item, index) in navData" :key="index" class="dituCon2" >
              <div class="dituTitle2">
                <a v-if="item.YijiLanmu=='首页' " @click="goHome">首页</a>
                <a v-else @click="goList2(0,item.ErJiLanMu[0].ErjiId,item.YijiLanmu)">{{item.YijiLanmu}}</a>
              </div>
              <div>
                <a v-if="item.YijiLanmu=='首页' " @click="goHome">首页</a>
                <a v-else @click="goList2(index2,li.ErjiId,item.YijiLanmu)" v-for="(li,index2) in item.ErJiLanMu" style="display: inline-flex;margin-right:50px;font-size: 15px;margin-bottom:15px;width:60px;">{{li.ErjiLanmu}}</a>
              </div>
      　　　 </div>
        </Drawer>
    </Col>
    <!-- 电脑端 -->
    <Col :xs="{ span: 0 }" :lg="{ span: 24}">
      <Col :xs="{ span: 0 }" :lg="{ span: 18 ,offset:3}">
        <div style="display:flex;align-items:center;height:35px;float:right">
          <img src="../assets/image/shoucang01.png" style="margin-right:5px;width:19px;height:19px">
          <div @click="shouchang" style="color:#fff;margin-top:2px;cursor:pointer;">收藏本站</div>
        </div>
        <!-- header -->
        <div style="width:100%;height:80px;display:flex;justify-content:space-between;align-items:center;margin-bottom:30px">
          <img src="../assets/image/logo.png" style="width:333px;height:81px">
          <img src="../assets/image/xiaoxun.png" style="width:251px;height:33px">
        </div>
        <!-- tab -->
        <Col :xs="{ span: 0 }" :lg="{ span: 24 }" v-if="this.$route.name=='Home'||this.$route.name=='menulist' ">
          <div style="display: flex;min-width: 1200px;">
              <div v-for="(item, index) in navData" :key="index"  @mouseenter="mouseEnter(index)" @mouseleave="mouseLeave" class="nav" >
                <div v-if="item.YijiLanmu!='首页'" style="flex-grow:1;text-align:center;">
                  <div class="itemTitle"  @click="goList2(0,item.ErJiLanMu[0].ErjiId,item.YijiLanmu)">{{item.YijiLanmu}}</div>
                  <div class="liSty" v-if="cindex==index">
                    <div v-for="(li, index2) in item.ErJiLanMu" :key="index2" class="navItem">
                      <div @click="goList2(index2,li.ErjiId,item.YijiLanmu)" style="height:35px;line-height:35px;">{{li.ErjiLanmu}}</div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div style="text-align:center" @click="goHome">{{item.YijiLanmu}}</div>
                </div>
      　　　　 </div>
          </div>
        </Col>
      </Col>
        
    </Col>
  </Row>
</div>
    
</template>
<script>
import { xxShouYeYiJi} from '@/api/index'
export default {
  name: 'Header',
  data(){
    return{
      navData: [],
      name:'',
      cindex:-1,
      chouti:false,//抽屉默认不显示
      organ_id:'',
    }
  },
  props:{
  },
  methods: {
    mouseEnter(index){
      this.cindex=index;
    },
    mouseLeave(){
      this.cindex=-1;
    },
    // Mark:收藏本站
    shouchang(){
      alert('请使用Ctrl+D将本页加入收藏夹！')
    },
    // Mark:二级菜单点击
    goList2(ind,id,name){
      if(name=='首页'){
        this.$router.push({name:'Home'})
        return
      }
      if(id == this.$route.query.id){
        return;
      }
      if(this.name ==name){
        return
      }
      this.cindex=-1;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$router.push({name:'menulist',query:{id:id,index:ind,isShow:false}});
    },
    // Mark:回到首页
    goHome(){
      if(this.$route.name=='Home'){
        return
      }
      this.$router.push({name:'Home'})
    },
    // 一级菜单鼠标离开事件
    // mouseleaveTabContentFun(){
    // }
  },
  created(){
    // window.addEventListener('scroll', this.mouseleaveTabContentFun, true);//监听鼠标滚动事件
    // tab
    this.organ_id=this.GLOBAL.organ_id;
    xxShouYeYiJi({organ_id:this.organ_id}).then(res=>{
      if(res.data.code){
         this.navData = res.data.data
      }
    })
  }
}
</script>

<style scoped lang="less">
.dituTitle2{
  margin-bottom:15px;
  font-weight: bold;
  font-size: 17px;
  // color:#ed4014;
}
.dituCon2{
  font-weight: bold;
  margin: 20px 0 50px 0;
}
.nav{
  line-height: 50px;
  background-color: #016bc1;
  // width:203px;
  height: 50px;
  margin-right:1px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  flex-grow:1;
  z-index:999;
}
.nav:hover {
  background:#c70000;
  color:#fff;
  cursor:pointer;
}
.navItem{
  background-color: #fff;
  font-weight: bold;
  color: #3f3f3f;
  border-radius:5px;
}
.navItem:hover {
  background:#c70000;
  cursor:pointer;
  color: #fff;
  border-radius:0px;
}
.liSty{
  background:#fff;
  border-radius:5px;
  color:#000;font-size:14px;
  text-align:center;
  width:80%;
  margin-left:10%;
}
.itemTitle{
  text-align:center;
  margin-bottom:5px
}
</style>
